export default __webpack_public_path__ + "static/media/illustration_sent.8711664b.svg";